import Layout from "@/layout/Layout";
import React from "react";
import CommercialPanel from "@/components/term/CommercialPanel";
import {useHistory} from "react-router";
import globalStyle from "@/styles/Global.scss";
import MButton from "@/components/atom/MButton";

const Commercial = () => {
  const history = useHistory()
  const goBack = () => {
    history.push(`/termInfo`)
  }
  return (
    <>
      <Layout title={'特定商取引に関する法律に基づく表記'}>
        <CommercialPanel/>
        <div style={{marginLeft: '100px'}}>
          <MButton image={'back.png'} onClick={goBack}/>
        </div>
      </Layout>
    </>
  )
}

export default Commercial
